<template>
  <div class="mx-auto animate-pulse">
    <IconifyIcon icon="mingcute:loading-line" class="animated-svg size-10 text-brand-primary" />
  </div>
</template>

<style lang="scss" scoped>
.animated-svg {
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(720deg);
  }
}
</style>
